import { IconButton } from "@mui/material";
import downloadInProgressTransactionsExcelSummary from "../../../common/downloadInProgressTransactionsExcelSummary";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';

const InProgressTransactionButtonSummary = () => {
  const handleDownload = () => {
    downloadInProgressTransactionsExcelSummary()
  }
  
  return (
    <IconButton
      color="warning"
      onClick={handleDownload}
    >
      <CloudDownloadIcon />
    </IconButton>
  )
}

export default InProgressTransactionButtonSummary;
